import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import StepLabel from "../StepLabel";
import Warning from "../Warning";
import {
  FormInput,
  FormPhoneInput,
  FormRadioGroup,
  FormSelectBrand,
} from "./form-inputs";
import { FormInputsContainer } from "./styles";
import { useFormContext } from "./form-context";

import { FormContainer } from "../../styles";
import { purchaseInfo } from "../../../../../../../redux/modules/staff-acess/actions";

export function CardMethod() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { cardForm } = useFormContext();
  const { control } = cardForm;

  return (
    <FormContainer autoComplete="off">
      <FormInputsContainer mb="16px">
        <FormSelectBrand
          control={control}
          name={"brand"}
          label={"select_card_brand"}
        />

        <FormRadioGroup
          control={control}
          name={"preference"}
          label={"select_card_type"}
        />

        <FormInput
          control={control}
          name={"cardReader"}
          label={"card_reader"}
          placeholder={intl.formatMessage({ id: "serial_number" })}
        />
      </FormInputsContainer>

      <StepLabel number={2} text={"buyer_info"} />

      <FormInputsContainer>
        <FormInput
          control={control}
          name={"name"}
          label={"name"}
          placeholder={intl.formatMessage({ id: "name" })}
        />

        <FormInput
          control={control}
          name={"document"}
          label={"CPF_or_passport"}
          placeholder="123.456.789-10 / AB0000000"
        />

        <FormPhoneInput
          control={control}
          name={"phone"}
          label={"phone2"}
          placeholder="(11) 98765-4321"
        />
      </FormInputsContainer>

      <Warning />
    </FormContainer>
  );
}
